module.exports = __webpack_public_path__ + "img/engineeringCases6.c49d90f9.png";